//midleware
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

const AuthenticateAndRolesMiddleware = ({ fallbackPath,module }) => {
      const { error } = useSelector((state) => state.userReducer);
      const isAuthenticated = Cookies.get("retailer_isAuthenticate");
      const token = Cookies.get("retailer_token");
    
      if (error == "jwt expired") {
        Cookies.remove("retailer_isAuthenticate");
        Cookies.remove("retailer_token");
        Cookies.remove("retailer_user_id");
        return <Navigate to={fallbackPath} />;
      } else {
        if (isAuthenticated === "true" && token) {
          return <Outlet />;
        } else {
          return <Navigate to={fallbackPath} />;
        }
      }
};

export default AuthenticateAndRolesMiddleware;